<template>
  <div class="p-4">
    <h1 class="text-2xl font-semibold mb-4">Nurses</h1>

    <EditableGrid
        :fetch-data-query="listNursesQuery"
        :update-mutation="updateReportMutation"
        :column-defs="columnDefs"
        primary-key="nurse_id"
        show-hospitals-dropdown
        require-hospital-selection
        :components="gridComponents"
        :context="gridContext"
        @hospital-changed="onSelectedHospitalChanged"
    />
  </div>
</template>

<script>
import EditableGrid from "@/components/common/EditableGrid.vue";
import HospitalSelector from "@/components/common/HospitalSelector.vue";
import TagsEditor from "@/components/users/TagsEditor.vue";

import {queryNursesByHospital, updateNurses} from '@/graphql/nurses.graphql';

import {useHospitalsStore} from "@/store/hospitals";

export default {
  name: 'UsersPage',
  components: {
    EditableGrid,
  },
  data() {
    const hospitalsStore = useHospitalsStore();

    return {
      listNursesQuery: queryNursesByHospital,
      updateReportMutation: updateNurses,
      // Column Definitions
      columnDefs: [
        {headerName: 'Nurse ID', field: 'nurse_id', tooltipField: 'nurse_id'},
        {headerName: 'Name', field: 'full_name', editable: true},
        {headerName: 'Hospital ID', field: 'hospital_id', editable: true, cellEditor: 'HospitalSelector'},
        {headerName: 'Phone Number', field: 'phone_number'},
        {
          headerName: 'Role',
          field: 'role_title',
          editable: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: () => ({values: hospitalsStore.getHospital(this.selectedHospital).roles.map((role) => role.role_title)})
        },
        {headerName: 'Display', field: 'is_selectable', editable: true},
        {headerName: 'Charge Currency', field: 'charge_currency', editable: true},
        {headerName: 'Is Admin', field: 'is_admin', editable: true},
        {
          headerName: 'Tags',
          field: 'tag_labels',
          cellEditor: 'TagsEditor',
          cellEditorParams: () => ({hospitalId: this.selectedHospital}),
          editable: true
        },
      ],
      gridComponents: {
        HospitalSelector,
        TagsEditor
      },
      gridContext: {
        componentParent: this, // Will be set in mounted()
      },
      gridApi: null,
      selectedHospital: ''
    };
  },
  methods: {
    onSelectedHospitalChanged(hospitalId) {
      this.selectedHospital = hospitalId;
    }
  }
};
</script>

<style scoped>
</style>
